import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';

import SelectCore from './SelectCore';

const EMPTY_OPTION = { value: '', label: '請選擇' };

function resolveOptionsWithEmpty(options, allowEmpty, isMulti) {
  if (!allowEmpty || isMulti) {
    return options;
  }

  const list = Array.isArray(options) ? options : [];
  const hasEmpty = list.some((option) => option.value === '' || option.value == null);
  if (hasEmpty) {
    return list;
  }

  return [EMPTY_OPTION, ...list];
}

const FloatingSelect = ({
  id,
  label,
  options,
  control,
  errors,
  isMulti = false,
  allowEmpty = false,
  onChange: customOnChange,
  ...props
}) => {
  const { field } = useController({
    name: id,
    control,
    defaultValue: isMulti ? [] : '',
  });

  const resolvedOptions = useMemo(
    () => resolveOptionsWithEmpty(options, allowEmpty, isMulti),
    [allowEmpty, isMulti, options],
  );

  return (
    <SelectCore
      id={id}
      label={label}
      options={resolvedOptions}
      value={field.value}
      onChange={(nextValue) => {
        field.onChange(nextValue);
        if (customOnChange) {
          customOnChange(nextValue);
        }
      }}
      onBlur={field.onBlur}
      isMulti={isMulti}
      errors={errors}
      {...props}
    />
  );
};

FloatingSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  tip: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isMulti: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  isClearable: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  classNames: PropTypes.object,
  containerClassName: PropTypes.string,
  isDisabled: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
};

export default FloatingSelect;
